import axios from 'axios';

export function deleteFile(id) {
  return axios.post(`/files/delete?id=${id}&force=true`);
}

export function checkFileExists(name) {
  return axios.get(`/files/checkexists?name=${name}`);
}
